import React from 'react'
import createReactClass from 'create-react-class'
import '../search-page/search-form-panel.scss'
import {AnalysisFormData} from '@/util/helpers'
import './analysis-form-panel.scss'

export default createReactClass({
  getInitialState () {
    return {
      params: {...AnalysisFormData.initialParams},
      columns: [],
      defaultCheckBox: true,
    }
  },

  resetForm (e) {
    e.preventDefault()
    this.setState({
      params: {...AnalysisFormData.initialParams},
      columns: [],
    })
  },

  updateValue (e) {
    let data = this.state.params
    data[e.target.id] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.setState({params: {...data}})
  },

  updateSelectedColumns (e) {
    if (e.target.id === 'all') {
      this.setState({defaultCheckBox: !this.state.defaultCheckBox})
      this.setState({columns: []})
    } else {
      // this.state.defaultCheckBox = false
      let keyName = e.target.id
      let cols = this.state.columns
      if (e.target.checked) {
        cols.push(keyName)
      } else {
        cols.splice(cols.indexOf(keyName), 1)
      }
      this.setState({columns: cols,
        defaultCheckBox: false})
    }
  },

  getSelectableFields () {
    return <div>
      <h5>Select fields</h5>
      <span className='selectable-field'>
        <input type='checkbox' id={'all'} checked={this.state.defaultCheckBox}
          onChange={this.updateSelectedColumns} />
        {'All'}
      </span>
      {AnalysisFormData.selectableFields.map((field, index) => {
        field.key = (field.key === 'ipAddress') ? 'clientAddress' : field.key
        return (
          <span key={index} className='selectable-field'>
            <input type='checkbox' id={field.key} key={index} checked={this.state.columns.indexOf(field.key) > -1 }
              onChange={this.updateSelectedColumns}/>
            {field.name}
          </span>)
      })
      }
    </div>
  },

  renderFormElement (data) {
    if (data.type === 'boolean') {
      return <input id={data.key} type="checkbox" onChange={this.updateValue} checked={this.state.params[data.key]}/>
    } else if (data.type === 'select') {
      return (
        <select className="form-control" id={data.key} onChange={this.updateValue} value={this.state.params[data.key]}>
          <option value=''>All APIs</option>
          {data.allowedValues.map((option, index) => {
            return <option key={index} value={option.value}>{option.name}</option>
          })}
        </select>
      )
    } else {
      return (<input className='form-control' id={data.key} type={data.type} onChange={this.updateValue}
        value={this.state.params[data.key]}/>)
    }
  },

  renderFormFields () {
    return AnalysisFormData.criteriaSets.map((field, index) => {
      return (<div className='form-group col-md-6 col-lg-4' key={index}>
        <label className='col-lg-4 col-md-5 col-sm-6 col-xs-12'>{field.name}</label>
        <div className='col-lg-8 col-md-7 col-sm-6 col-xs-12'>
          {this.renderFormElement(field)}
        </div>
      </div>)
    })
  },

  searchLogs (e) {
    this.props.onPageChange(1)
    e.preventDefault()
    this.props.getLogs(this.state, 1, this.props.pageSize)
  },

  render () {
    return (
      <div className="search-form-panel">
        <form>
          <div className='row'>
            {this.renderFormFields()}
          </div>
          <div>
            {this.getSelectableFields()}
          </div>
          <div className='pull-right'>
            <button type='reset' className='cs-grey-button' onClick={this.resetForm}>Clear</button>
            <button type='submit' className='cs-primary-button' onClick={this.searchLogs} disabled={this.props.loader}>
              {this.props.loader ? <i className="fa fa-spinner fa-spin"></i> : '' }Find</button>
          </div>
        </form>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/analysis-page/analysis-form-panel.js